var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"etc-h5"},[_c('img',{staticClass:"bg",attrs:{"src":require("../../assets/some/etc-h5-bg.jpg"),"alt":""}}),_c('img',{staticClass:"code",attrs:{"src":require("../../assets/some/etc-h5-code.png"),"alt":""}})])
}]

export { render, staticRenderFns }